<template>
  <div class="utentiaziendeview">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Dati dell'azienda</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="codice" v-model="formData.anagrafica.codice" type="text" :state="state.codice" placeholder="Codice dell'installatore" disabled/><label for="codice">* Codice</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="8">
          <b-form-input class="slide-up" id="denominazione" v-model="formData.anagrafica.denominazione" type="text" :state="state.denominazione" placeholder="Denominazione dell'installatore"/><label for="denominazione">* Denominazione</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cf" v-model="formData.anagrafica.cf" type="text" :state="state.cf" placeholder="Codice fiscale dell'installatore" /><label for="cf">Codice Fiscale</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="piva" v-model="formData.anagrafica.piva" type="text" :state="state.piva" placeholder="Partita IVA dell'installatore" /><label for="piva">* Partita IVA</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>RESIDENZA</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" offset-md="1" md="10">
          <b-form-input id="search_box" type="search" placeholder="Seleziona il tuo indirizzo" :state="state.search_address" autocomplete="off"></b-form-input>
          <div id="ubicazione_map"></div>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>ALTRE INFORMAZIONI</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="website" v-model="formData.anagrafica.website" type="text" :state="state.website" placeholder="Sito web dell'installatore" /><label for="website">Sito web</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="email" v-model="formData.user.email" type="text" :state="state.email" placeholder="Email dell'installatore" /><label for="email">Email *</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="cellulare" v-model="formData.anagrafica.cellulare" type="text" :state="state.cellulare" placeholder="Numero di cellulare dell'installatore" /><label for="cellulare">Cellulare</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="telefono" v-model="formData.anagrafica.telefono" type="text" :state="state.telefono" placeholder="Numero del telefono fisso dell'installatore" /><label for="telefono">Telefono fisso</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="fax" v-model="formData.anagrafica.fax" type="text" :state="state.fax" placeholder="Numero del Fax dell'installatore" /><label for="fax">Fax</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.anagrafica.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>LICENZA AZIENDA</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" cols="12">
          <VueCtkDateTimePicker v-model="formData.licenza.da" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
            <b-form-input v-model="formData.licenza.da" class="slide-up fix_datetime_picker" :state="state.da" id="da" type="text" placeholder="Data di inizio della licenza"/><label for="da">* Data Attivazione</label>
          </VueCtkDateTimePicker>
          <br>
          <br>
        </b-col>
        <b-col md="6" cols="12">
          <VueCtkDateTimePicker v-model="formData.licenza.a" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
            <b-form-input v-model="formData.licenza.a" class="slide-up fix_datetime_picker" :state="state.a" id="a" type="text" placeholder="Data di scadenza della licenza"/><label for="a">* Data Scadenza</label>
          </VueCtkDateTimePicker>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" cols="12">
          <b-form-input class="slide-up" id="num_installatori" v-model="formData.licenza.num_installatori" :state="state.num_installatori" type="number" placeholder="Numero di installatori per la licenza"/><label for="num_installatori">* Numero Installatori</label>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-input class="slide-up" id="chiave" v-model="formData.licenza.chiave" :state="state.chiave" type="text" placeholder="Chiave da dare all'installatore per la licenza"/><label for="chiave">* Chiave Licenza</label>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>STATO AZIENDA</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col>
          <b-form-radio-group v-model="formData.anagrafica.stato" buttons>
            <b-form-radio :value="0" button-variant="outline-secondary">In Attesa</b-form-radio>
            <b-form-radio :value="1" button-variant="outline-success">Attivato</b-form-radio>
            <b-form-radio :value="2" button-variant="outline-dark">Rifiutato</b-form-radio>
            <b-form-radio :value="3" button-variant="outline-danger">Scaduto</b-form-radio>
            <b-form-radio :value="4" button-variant="outline-warning">In Scadenza</b-form-radio>
            <b-form-radio :value="5" button-variant="outline-info">Rinnovato</b-form-radio>
            <b-form-radio :value="6" button-variant="outline-dark">Disabilitato</b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="updateAzienda()"><font-awesome-icon icon="plus-circle" /> Aggiorna</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { globalConf } from '../../../config.global'

var map
var markers

export default {
  name: 'utentiaziendeview',
  data() {
    return {
      state: {
        codice: null,
        denominazione: null,
        cf: null,
        piva: null,
        website: null,
        cellulare: null,
        telefono: null,
        fax: null,
        note: null,
        email: null,
        search_address: null,
        da: null,
        a: null,
        num_installatori: null,
        chiave: null
      },
      formData:{
        anagrafica: {
          codice: '',
          denominazione: '',
          cf: '',
          piva: '',
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
          website: '',
          cellulare: '',
          telefono: '',
          fax: '',
          note: '',
          stato: 0
        }, 
        user: {
          email: ''
        },
        licenza: {
          da: '',
          a: '',
          num_installatori: 0,
          chiave: ''
        }
      }
    }
  },
  mounted: function(){
    this.loadAzienda()
  },
  methods: {
    loadMap(){
      map = new google.maps.Map(document.getElementById('ubicazione_map'), {
        center: {lat: 42.504154, lng: 12.646361},
        streetViewControl: false,
        zoom: 6
      })

      var input = document.getElementById('search_box')
      var searchBox = new google.maps.places.SearchBox(input)
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

      document.getElementById('search_box').value = this.formData.anagrafica.via+", "+this.formData.anagrafica.civico+", "+this.formData.anagrafica.cap+
                      " "+this.formData.anagrafica.comune+" "+this.formData.anagrafica.provincia+", "+this.formData.anagrafica.nazione

      var localthis = this
      
      var service = new google.maps.places.PlacesService(map);
      
      var request = {
        query: document.getElementById('search_box').value,
        fields: ['formatted_address', 'geometry', 'html_attributions', 'icon', 'id', 'name', 'place_id', 'plus_code', 'reference', 'types'],
      }

      service.findPlaceFromQuery(request, function(results, status) {
        localthis.setMap(results)
      })

      map.addListener('bounds_changed', function() {
        searchBox.setBounds(map.getBounds())
      })

      markers = []

      searchBox.addListener('places_changed', function() {
        var places = searchBox.getPlaces()

        localthis.setMap(places)
      })
    },
    setMap(places){
      this.state.search_address = null
      var check_msg = this.checkAddress(places)
      if(check_msg != ""){
        Vue.notify({
          group: 'global',
          title: 'Ubicazione errata!',
          text: check_msg,
          type: 'error'
        })
        this.state.search_address = false
        return
      }

      this.setByPlace(places)

      markers.forEach(function(marker) {
        marker.setMap(null)
      })
      markers = []

      var bounds = new google.maps.LatLngBounds()
      places.forEach(function(place) {
        if (!place.geometry) {
          console.log("Returned place contains no geometry")
          return
        }
        var icon = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25)
        }

        markers.push(new google.maps.Marker({
          map: map,
          icon: icon,
          title: place.name,
          position: place.geometry.location
        }))

        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })
      map.fitBounds(bounds)
    },
    checkAddress(places){
      this.formData.anagrafica.via = ''
      this.formData.anagrafica.civico = ''
      this.formData.anagrafica.nazione = ''
      this.formData.anagrafica.cap = ''
      this.formData.anagrafica.provincia = ''
      this.formData.anagrafica.comune = ''

      if(places.length == 0 || places.length > 1){
        return "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"
      }

      var luogo = places[0].formatted_address

      document.getElementById('search_box').value = luogo
      
      var campi = luogo.split(",")

      if(campi.length != 4){
        return "L'indirizzo inserito non è completo di tutte le informazioni necessarie!"
      }

      if(campi[1].trim().split(" ").length != 1){
        return "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"
      }

      if(!(campi[3].trim() == "Italia" || campi[3].trim() == "Italy")){
        return "Attualmente sono supportati solo indirizzi italiani! Per qualsiasi dubbio contattare l'assistenza."
      }

      var sub_campi = campi[2].trim().split(" ")

      if(sub_campi.length < 3)
        return "L'indirizzo inserito non è valido!"

      if(isNaN(Number.parseInt(sub_campi[0].trim())))
        return "L'indirizzo inserito non contiene un CAP valido! Riprovare."

      if(sub_campi[sub_campi.length - 1].trim().length != 2)
        return "La provincia inserita non è valida!"

      return ""
    },
    setByPlace(places){
      var luogo = places[0].formatted_address
      console.log(luogo)

      document.getElementById('search_box').value = luogo

      var campi = luogo.split(",")

      this.formData.anagrafica.via = campi[0]
      this.formData.anagrafica.civico = campi[1]
      this.formData.anagrafica.nazione = campi[3] //TODO: se cerco indirizzo fuori italia ho problemi nella formattazione dell'indirizzo

      var sub_campi = campi[2].split(" ")

      this.formData.anagrafica.cap = sub_campi[1]
      this.formData.anagrafica.provincia = sub_campi[sub_campi.length - 1]
      this.formData.anagrafica.comune = sub_campi.slice(2, sub_campi.length - 1).join(" ")
    },
    loadAzienda(){
      Vue.http.post('utente/aziende/load/'+this.$route.params.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.formData = response.body.data

          Vue.loadScript("https://maps.googleapis.com/maps/api/js?key="+globalConf.gmaps+"&libraries=places")
          .then(() => {
            this.loadMap()
          })
          .catch(() => {
            console.log("Errore durante il caricamento di Google Maps!")
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Problemi durante il caricamento dell\'azienda',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    updateAzienda(){
      Vue.http.post('utente/aziende/update/'+this.$route.params.id, this.formData, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Azienda aggiornato con successo!',
            type: 'success'
          })
          this.$router.push('/utenti/aziende')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la registrazione',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    }
  }
}
</script>

<style scoped>
#search_box{
  width: 60%;
  margin-top: 10px;
  margin-left: 20px;
}

#ubicazione_map{
  width: 100%;
  height: 400px;
  border-radius: 4px;

  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

#codice{
  text-indent: 90px;
}

#denominazione{
  text-indent: 150px;
}

#cf{
  text-indent: 140px;
}

#piva{
  text-indent: 110px;
}

#website{
  text-indent: 95px;
}

#cellulare{
  text-indent: 95px;
}

#telefono{
  text-indent: 130px;
}

#fax{
  text-indent: 60px;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}

#email{
  text-indent: 85px;
}

#da{
  text-indent: 140px;
}

#a{
  text-indent: 125px;
}

#num_installatori{
  text-indent: 180px;
}

#chiave{
  text-indent: 155px;
}
</style>